import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Invoice } from '../models/invoice.model';
import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/compat/firestore';
import { Moment } from 'moment';

@Injectable({ providedIn: 'root' })
export class InvoiceService {
  private invoiceCollection: AngularFirestoreCollection;

  constructor(
    private firestore$: AngularFirestore
  ) {
    this.invoiceCollection = this.firestore$.collection('invoices');
  }

  getInvoiceByMonth(date: Moment): Observable<Invoice[]> {
    return this.invoiceCollection
      .doc(date.year().toString())
      .collection<Invoice>(date.format('MM'))
      .valueChanges({ idField: 'id' });
  }
}
